module.exports = __webpack_public_path__ + "img/ics_o_ubah_tagihan.462c1240.svg";